export default "__VITE_ASSET__$36Ymn4Z__"